import '../payment-message-dialog.scss';

export default class VisionCancelCtrl {

    // @ngInject
    constructor(OrderResource) {
        this.orderResource = OrderResource;
    }

    next() {
        window.location.reload();
    }

    cancelSubscription() {
        this.$loading = true;
        this.orderResource.cancelSubscription().$promise.then(() => {
            this.next();
        });
    }
}



// WEBPACK FOOTER //
// ./payments/vision-cancel/vision-cancel.js